const determinePurpose = (purpose?: string, purposeType?: string, invoiceDate?: string, invoiceNumber?: string): string | undefined => {
  if (purposeType === 'Service' && invoiceDate && invoiceNumber) {
    return `${purpose?.replace(' -', ',')}, INVOICE NO.- ${invoiceNumber}, INVOICE DATE:- ${invoiceDate}`;
  }

  if (purposeType === 'Unspecified') {
    return purpose;
  }

  if (purpose && purposeType !== 'Service') {
    return purpose;
  }

  return '';
};

export default determinePurpose;
